<template>
  <b-container fluid class="text-dark">
      <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('delivery_management.distribution') }}</h4>
        </template>
        <template v-slot:headerAction>
          <router-link to="pending-demand-list" :class="'btn btn-primary text-light'">{{  $t('delivery_management.pending_demand') }} {{ $t('globalTrans.list') }}</router-link>
        </template>
        <b-row>
            <b-col lg="12" sm="12">
            <iq-card>
            <template v-slot:body>
              <b-overlay :show="loading">
                <!-- Application Details -->
                    <b-row>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('assitive_device_management.application_type')}}: </span>{{application_type}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.application_id')}}: </span>{{$n( application_id, { useGrouping: false })}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('child_reports.application_date')}}: </span>{{profile.application_date | dateFormat}}
                        </b-col>
                    </b-row>
                    <b-row v-if="application_type_id === 1">
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.name')}}: </span>{{ ($i18n.locale === 'bn') ? profile.name_bn : profile.name }}
                        </b-col>
                        <!-- <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.age')}}: </span>{{$n( profile.age, { useGrouping: false })}} {{ $t('globalTrans.year')}}
                        </b-col> -->
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.gender')}}: </span>{{ profile.gender }}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.father_name')}}: </span>{{profile.father_name}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.mother_name')}}: </span>{{profile.mother_name}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('supply_info.contact_no')}}: </span>{{$n(profile.mobile, {useGrouping: false})}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('assitive_device_management.yearly_family_income')}}: </span>{{$n(profile.yearly_family_income, {useGrouping: false})}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('info_manage.disability_type')}}: </span>{{ profile.disability_type }}
                        </b-col>
                    </b-row>
                    <b-row v-if="application_type_id > 1">
                        <b-col lg="4" sm="4" v-if="application_type_id === 2">
                            <span class="font-weight-bold">{{ $t('child_admission_management.applicant_name')}}: </span>{{organization.applicant_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="application_type_id === 3">
                            <span class="font-weight-bold">{{ $t('assitive_device_management.representative_name')}}: </span>{{organization.representative_name}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.designation')}}: </span>{{organization.designation}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('child_admission_management.organization_name')}}: </span>{{organization.organization_name}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('supply_info.contact_no')}}: </span>{{$n(organization.contact_no, {useGrouping: false})}}
                        </b-col>
                    </b-row>
                    <!-- Address Details -->
                    <!-- present Address start -->
                    <br>
                    <b-row>
                        <b-col>
                            <h5 v-if="application_type_id === 1"><b><u>{{$t('globalTrans.present_address')}}</u></b></h5><hr v-if="application_type_id === 1">
                            <h5 v-if="application_type_id > 1">{{$t('globalTrans.address')}}</h5><hr v-if="application_type_id > 1">
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.division')}}: </span>{{address.pre_division_name}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.district')}}: </span>{{address.pre_discrict_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.pre_upazilla_name">
                            <span class="font-weight-bold">{{ $t('org_pro_upazilla.upazilla')}}: </span>{{address.pre_upazilla_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.pre_union_name">
                            <span class="font-weight-bold">{{ $t('org_pro_union.union')}}: </span>{{address.pre_union_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.pre_city_corporation_name">
                            <span class="font-weight-bold">{{ $t('org_pro.city_corporation')}}: </span>{{address.pre_city_corporation_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.pre_pauroshoba_name">
                            <span class="font-weight-bold">{{ $t('org_pro.pauroshoba')}}: </span>{{address.pre_pauroshoba_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.pre_ward_name">
                            <span class="font-weight-bold">{{ $t('org_pro.ward')}}: </span>{{address.pre_ward_name}}
                        </b-col>
                        <b-col lg="12" sm="12" md="12">
                            <span class="font-weight-bold">{{ $t('globalTrans.address')}}: </span>{{address.pre_address}}
                        </b-col>
                    </b-row>
                    <!-- present address end -->
                    <!-- permanent address start -->
                    <br v-if="application_type_id === 1">
                    <b-row v-if="application_type_id === 1">
                        <b-col>
                            <h5><b><u>{{$t('globalTrans.permanent_address')}}</u></b></h5><hr>
                        </b-col>
                    </b-row>
                    <b-row v-if="application_type_id === 1">
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.division')}}: </span>{{address.per_division_name}}
                        </b-col>
                        <b-col lg="4" sm="4">
                            <span class="font-weight-bold">{{ $t('globalTrans.district')}}: </span>{{address.per_discrict_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.per_upazilla_name">
                            <span class="font-weight-bold">{{ $t('org_pro_upazilla.upazilla')}}: </span>{{address.per_upazilla_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.per_union_name">
                            <span class="font-weight-bold">{{ $t('org_pro_union.union')}}: </span>{{address.per_union_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.per_city_corporation_name">
                            <span class="font-weight-bold">{{ $t('org_pro.city_corporation')}}: </span>{{address.per_city_corporation_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.per_pauroshoba_name">
                            <span class="font-weight-bold">{{ $t('org_pro.pauroshoba')}}: </span>{{address.per_pauroshoba_name}}
                        </b-col>
                        <b-col lg="4" sm="4" v-if="address.per_ward_name">
                            <span class="font-weight-bold">{{ $t('org_pro.ward')}}: </span>{{address.per_ward_name}}
                        </b-col>
                        <b-col lg="12" sm="12" md="12">
                            <span class="font-weight-bold">{{ $t('globalTrans.address')}}: </span>{{address.per_address}}
                        </b-col>
                    </b-row>
                    <!-- permanent address end -->
                    <br>
                    <!-- Assistive Device List Start-->
                    <b-row>
                        <b-col>
                            <b-overlay :show="unitLoad">
                              <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                                  <table class="table table-bordered">
                                      <tr class="bg-light">
                                          <th>{{$t('hospital_information.sl')}}</th>
                                          <th>{{$t('assitive_device_management.device_name')}}</th>
                                          <th>{{$t('delivery_management.stock_quantity')}}</th>
                                          <th>{{$t('assitive_device_management.no_of_quantity_list')}}</th>
                                          <th>{{$t('assitive_device_management.approved_quantity')}}</th>
                                          <th>{{$t('delivery_management.previous_distributed_quantity')}}</th>
                                          <th>{{$t('delivery_management.distributed_quantity')}}</th>
<!--                                          <th>{{$t('child_admission_management.reason')}}</th>-->
                                      </tr>
                                      <tr v-for="(item, index) in formData.details" :key="index">
                                          <td>{{ $n(index + 1) }}</td>
                                          <td>
                                              {{ getDeviceName(item.assistive_device_id) }}
                                          </td>
                                          <td class="text-right">
                                            {{ $n(item.stock_quantity, {useGrouping: false})}}
                                          </td>
                                          <td class="text-right">
                                              {{ $n(item.no_of_quantity, {useGrouping: false})}}
                                          </td>
                                          <td class="text-right">
                                              {{ $n(item.approved_quantity, {useGrouping: false})}}
                                          </td>
                                          <td class="text-right">
                                            {{ $n(item.previous_distributed_quantity, {useGrouping: false})}}
                                          </td>
                                          <td>
                                            <ValidationProvider name="Distributed Quantity" :vid="'details.'+index+'.distributed_quantity'" :rules="getDistributedQuantityRules(item)">
                                              <b-form-group
                                                  :label-for="'details.'+index+'.distributed_quantity'"
                                                  slot-scope="{ valid, errors }"
                                              >
                                                <b-form-input
                                                    :id="'details.'+index+'.distributed_quantity'"
                                                    v-model="item.distributed_quantity"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    @keyup="getTotalInfo"
                                                    @keypress="isNumber($event)"
                                                ></b-form-input>
                                                <div class="invalid-feedback">
                                                  {{ errors[0] }}
                                                </div>
                                              </b-form-group>
                                            </ValidationProvider>
                                          </td>
<!--                                          <td>-->
<!--                                              {{ lang === 'bn'? item.reason_bn : item.reason_en }}-->
<!--                                          </td>-->
                                      </tr>
                                    <tr>
                                      <th class="text-right" colspan="2">{{ $t('sitePreference.grandTotal') }}</th>
                                      <th class="text-right">{{ $n(totalInfo.stock_quantity) }}</th>
                                      <th class="text-right">{{ $n(totalInfo.no_of_quantity) }}</th>
                                      <th class="text-right">{{ $n(totalInfo.approved_quantity) }}</th>
                                      <th class="text-right">{{ $n(totalInfo.previous_distributed_quantity) }}</th>
                                      <th class="text-right">{{ $n(totalInfo.distributed_quantity) }}</th>
                                    </tr>
                                  </table>
                                  <div class="row">
                                    <div class="col-sm-3"></div>
                                    <div class="col text-right">
                                      <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.save') }}</b-button>
                                    </div>
                                  </div>
                                </b-form>
                              </ValidationObserver>
                            </b-overlay>
                        </b-col>
                    </b-row>
                    <!-- Assistive Device List End-->
              </b-overlay>
            </template>
            </iq-card>
            </b-col>
        </b-row>
    </iq-card>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { mapGetters } from 'vuex'
import { helpers } from '@/mixins/helper-functions'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { distributionListApplication, distributionListDistribute } from '../../api/routes'

export default {
props: ['item'],
data () {
    return {
        id: this.$route.query.id,
        lang: this.$i18n.locale,
        application_type: 0,
        application_type_id: 0,
        application_id: 0,
        profile: {
            application_type: 1,
            application_id: 1,
            profile_id: '',
            name: '',
            name_bn: '',
            father_name: '',
            father_name_bn: '',
            mother_name: '',
            mother_name_bn: '',
            nid: '',
            birth_id: '',
            dss_id: '',
            contact_no: '',
            gender: 0,
            disability_type: '',
            disability_type_id: 0,
            assistive_device_id: 0,
            birth_date: '',
            is_same_as_present: 0,
            pre_area_type_id: 0,
            pre_city_corporation_id: 0,
            pre_pauroshoba_id: 0,
            pre_division_id: 0,
            pre_district_id: 0,
            pre_upazilla_id: 0,
            pre_union_id: 0,
            pre_ward_id: 0,
            pre_post_code: '',
            pre_post_office: '',
            pre_address_en: '',
            pre_address_bn: '',
            per_area_type_id: 0,
            per_city_corporation_id: 0,
            per_pauroshoba_id: 0,
            per_division_id: 0,
            per_district_id: 0,
            per_upazilla_id: 0,
            per_union_id: 0,
            per_ward_id: 0,
            per_post_code: '',
            per_post_office: '',
            per_address_en: '',
            per_address_bn: '',
            no_of_quantity: 0,
            reason_en: '',
            reason_bn: '',
            recommendation: 0,
            center_id: 0,
            service_type_id: 0,
            attachment: []
        },
        organization: {
            application_type: 1,
            applicant_name_en: '',
            applicant_name_bn: '',
            representative_name_en: '',
            representative_name_bn: '',
            designation_en: '',
            designation_bn: '',
            organization_name_en: '',
            organization_name_bn: '',
            contact_no: '',
            email: '',
            deviceList: [],
            attachment: [],
            is_same_as_present: 1,
            pre_area_type_id: 0,
            pre_city_corporation_id: 0,
            pre_pauroshoba_id: 0,
            pre_division_id: 0,
            pre_district_id: 0,
            pre_upazilla_id: 0,
            pre_union_id: 0,
            pre_ward_id: 0,
            pre_post_code: '',
            pre_post_office: '',
            pre_address_en: '',
            pre_address_bn: '',
            fiscal_year_id: 0,
            application_date: '',
            recommendation: 0,
            center_id: 0
        },
        address: [],
        unitLoad: false,
        formData: {
          details: []
        },
      loading: false,
      totalInfo: {
          stock_quantity: 0,
          no_of_quantity: 0,
          approved_quantity: 0,
          previous_distributed_quantity: 0,
          distributed_quantity: 0
      }
    }
},
computed: {
    ...mapGetters({
        commonObj: 'HospitalDisabilityService/commonObj'
    }),
    currentLocale () {
      return this.$i18n.locale
    }
  },
created () {
    if (this.$route.query.id) {
            this.getData()
        // } catch (e) {
        // }
    }
},
mounted () {
    core.index()
},
methods: {
     profileInfoById () {
      const loadData = this.formData
        this.application_type_id = loadData.application_type
        this.application_id = this.$route.query.id
        if (loadData.application_type === 1) {
            this.profile = loadData
            this.profile.age = this.calculateAge(loadData.birth_date)
          const patient = this.$store.state.AwarenessEventService.commonObj.patientList.find(item => item.value === this.profile.patient_id)
          const gender = this.$store.state.commonObj.genderList.find(item => item.value === parseInt(patient.gender))
          const patientCustom = {
              name: patient?.text_en,
              name_bn: patient?.text_bn,
              father_name: patient?.father_name,
              father_name_bn: patient?.father_name_bn,
              mother_name: patient?.mother_name,
              mother_name_bn: patient?.mother_name_bn,
              mobile: patient?.mobile,
              gender: this.currentLocale === 'en' ? gender?.text_en : gender?.text_bn
          }
          this.profile = Object.assign({}, this.profile, patientCustom)
        } else {
            this.organization = loadData
            this.organization.deviceList = loadData.details
        }
      const applicationTypeData = this.$store.state.AwarenessEventService.commonObj.assitiveDeviceApplicationTypeList.find(item => item.value === this.application_type_id)
      const preDistrictbbjectData = this.$store.state.commonObj.districtList.find(item => item.value === (this.application_type_id === 1 ? this.profile.pre_district_id : this.organization.pre_district_id))
      const preDivisionbbjectData = this.$store.state.commonObj.divisionList.find(item => item.value === (this.application_type_id === 1 ? this.profile.pre_division_id : this.organization.pre_division_id))
      const prePouroshaObjectData = this.$store.state.commonObj.pauroshobaList.find(item => item.value === (this.application_type_id === 1 ? this.profile.pre_pauroshoba_id : this.organization.pre_pauroshoba_id))
      const preCitycorpObjectData = this.$store.state.commonObj.cityCorporationList.find(item => item.value === (this.application_type_id === 1 ? this.profile.pre_city_corporation_id : this.organization.pre_city_corporation_id))
      const preUpazillaObjectData = this.$store.state.commonObj.upazilaList.find(item => item.value === (this.application_type_id === 1 ? this.profile.pre_upazilla_id : this.organization.pre_upazilla_id))
      const preUnionObjectData = this.$store.state.commonObj.unionList.find(item => item.value === (this.application_type_id === 1 ? this.profile.pre_union_id : this.organization.pre_union_id))
      const preWardObjectData = this.$store.state.commonObj.wardList.find(item => item.value === (this.application_type_id === 1 ? this.profile.pre_ward_id : this.organization.pre_ward_id))
      const perDistrictbbjectData = this.$store.state.commonObj.districtList.find(item => item.value === (this.application_type_id === 1 ? this.profile.per_district_id : this.organization.per_district_id))
      const perDivisionbbjectData = this.$store.state.commonObj.divisionList.find(item => item.value === (this.application_type_id === 1 ? this.profile.per_division_id : this.organization.per_division_id))
      const perPouroshaObjectData = this.$store.state.commonObj.pauroshobaList.find(item => item.value === (this.application_type_id === 1 ? this.profile.per_pauroshoba_id : this.organization.per_pauroshoba_id))
      const perCitycorpObjectData = this.$store.state.commonObj.cityCorporationList.find(item => item.value === (this.application_type_id === 1 ? this.profile.per_city_corporation_id : this.organization.per_city_corporation_id))
      const perUpazillaObjectData = this.$store.state.commonObj.upazilaList.find(item => item.value === (this.application_type_id === 1 ? this.profile.per_upazilla_id : this.organization.per_upazilla_id))
      const perUnionObjectData = this.$store.state.commonObj.unionList.find(item => item.value === (this.application_type_id === 1 ? this.profile.per_union_id : this.organization.per_union_id))
      const perWardObjectData = this.$store.state.commonObj.wardList.find(item => item.value === (this.application_type_id === 1 ? this.profile.per_ward_id : this.organization.per_ward_id))
      // const tmpGender = this.$store.state.commonObj.genderList.find(item => item.value === this.profile.gender)
      const disabilityTypeData = this.$store.state.AwarenessEventService.commonObj.disabilityTypeList.find(item => item.value === this.profile.disability_type_id)
      const deviceTypeData = this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(item => item.value === this.profile.assistive_device_id)
      if (this.$i18n.locale === 'bn') {
        this.application_type = applicationTypeData ? applicationTypeData.text_bn : ''
        this.profile.disability_type = disabilityTypeData ? disabilityTypeData.text_bn : ''
        this.profile.device_name = deviceTypeData ? deviceTypeData.text_bn : ''
        // this.profile.gender = tmpGender ? tmpGender.text_bn : ''
        this.profile.father_name = this.profile.father_name_bn ? this.profile.father_name_bn : ''
        this.profile.mother_name = this.profile.mother_name_bn ? this.profile.mother_name_bn : ''
        this.profile.reason = this.profile.reason_bn ? this.profile.reason_bn : ''
        // address
        this.address.pre_address = this.application_type_id === 1 ? (this.profile.pre_address_bn ? this.profile.pre_address_bn : '') : (this.organization.pre_address_bn ? this.organization.pre_address_bn : '')
        this.address.pre_discrict_name = preDistrictbbjectData ? preDistrictbbjectData.text_bn : ''
        this.address.pre_division_name = preDivisionbbjectData ? preDivisionbbjectData.text_bn : ''
        this.address.pre_pauroshoba_name = prePouroshaObjectData ? prePouroshaObjectData.text_bn : ''
        this.address.pre_city_corporation_name = preCitycorpObjectData ? preCitycorpObjectData.text_bn : ''
        this.address.pre_upazilla_name = preUpazillaObjectData ? preUpazillaObjectData.text_bn : ''
        this.address.pre_union_name = preUnionObjectData ? preUnionObjectData.text_bn : ''
        this.address.pre_ward_name = preWardObjectData ? preWardObjectData.text_bn : ''
        this.address.per_address = this.profile.per_address_bn ? this.profile.per_address_bn : ''
        this.address.per_discrict_name = perDistrictbbjectData ? perDistrictbbjectData.text_bn : ''
        this.address.per_division_name = perDivisionbbjectData ? perDivisionbbjectData.text_bn : ''
        this.address.per_pauroshoba_name = perPouroshaObjectData ? perPouroshaObjectData.text_bn : ''
        this.address.per_city_corporation_name = perCitycorpObjectData ? perCitycorpObjectData.text_bn : ''
        this.address.per_upazilla_name = perUpazillaObjectData ? perUpazillaObjectData.text_bn : ''
        this.address.per_union_name = perUnionObjectData ? perUnionObjectData.text_bn : ''
        this.address.per_ward_name = perWardObjectData ? perWardObjectData.text_bn : ''
        // organization
        this.organization.applicant_name = this.organization.applicant_name_bn ? this.organization.applicant_name_bn : ''
        this.organization.designation = this.organization.designation_bn ? this.organization.designation_bn : ''
        this.organization.representative_name = this.organization.representative_name_bn ? this.organization.representative_name_bn : ''
        this.organization.organization_name = this.organization.organization_name_bn ? this.organization.organization_name_bn : ''
      } else {
        this.application_type = applicationTypeData ? applicationTypeData.text_en : ''
        this.profile.disability_type = disabilityTypeData ? disabilityTypeData.text_en : ''
        this.profile.device_name = deviceTypeData ? deviceTypeData.text_en : ''
        // this.profile.gender = tmpGender ? tmpGender.text_en : ''
        this.profile.reason = this.profile.reason_en ? this.profile.reason_en : ''
        // address
        this.address.pre_address = this.application_type_id === 1 ? (this.profile.pre_address_en ? this.profile.pre_address_en : '') : (this.organization.pre_address_en ? this.organization.pre_address_en : '')
        this.address.pre_discrict_name = preDistrictbbjectData ? preDistrictbbjectData.text_en : ''
        this.address.pre_division_name = preDivisionbbjectData ? preDivisionbbjectData.text_en : ''
        this.address.pre_pauroshoba_name = prePouroshaObjectData ? prePouroshaObjectData.text_en : ''
        this.address.pre_city_corporation_name = preCitycorpObjectData ? preCitycorpObjectData.text_en : ''
        this.address.pre_upazilla_name = preUpazillaObjectData ? preUpazillaObjectData.text_en : ''
        this.address.pre_union_name = preUnionObjectData ? preUnionObjectData.text_en : ''
        this.address.pre_ward_name = preWardObjectData ? preWardObjectData.text_en : ''
        this.address.per_address = this.profile.per_address_en ? this.profile.per_address_en : ''
        this.address.per_discrict_name = perDistrictbbjectData ? perDistrictbbjectData.text_en : ''
        this.address.per_division_name = perDivisionbbjectData ? perDivisionbbjectData.text_en : ''
        this.address.per_pauroshoba_name = perPouroshaObjectData ? perPouroshaObjectData.text_en : ''
        this.address.per_city_corporation_name = perCitycorpObjectData ? perCitycorpObjectData.text_en : ''
        this.address.per_upazilla_name = perUpazillaObjectData ? perUpazillaObjectData.text_en : ''
        this.address.per_union_name = perUnionObjectData ? perUnionObjectData.text_en : ''
        this.address.per_ward_name = perWardObjectData ? perWardObjectData.text_en : ''
        // organization
        this.organization.applicant_name = this.organization.applicant_name_en ? this.organization.applicant_name_en : ''
        this.organization.designation = this.organization.designation_en ? this.organization.designation_en : ''
        this.organization.representative_name = this.organization.representative_name_en ? this.organization.representative_name_en : ''
        this.organization.organization_name = this.organization.organization_name_en ? this.organization.organization_name_en : ''
      }
    },
    async getData () {
       this.loading = true
        const result = await RestApi.getData(awarenessEventServiceBaseUrl, distributionListApplication + '/' + this.id)
      if (result.success) {
        this.formData = result.data
        // this.formData.details = this.formData.details.map(item => {
        //   const customItem = {
        //     previous_distributed_quantity: item.distributed_quantity,
        //     distributed_quantity: 0
        //   }
        //   return Object.assign({}, item, customItem)
        // })
        this.profileInfoById()
        this.getTotalInfo()
        this.loading = false
      } else {
        this.formData = []
        this.loading = false
      }
    },
    getDeviceName (deviceId) {
        const tmpData = this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(item => item.value === parseInt(deviceId))
        return tmpData.text
    },
    calculateAge (dateString) {
        return helpers.calculateAge(dateString)
    },
    getGenderinfo (id) {
          const genderData = this.$store.state.genderList.find(gender => gender.value === 1)
          return JSON.parse(JSON.stringify(genderData))
    },
    getDistrictList (districtnId = null) {
        const districtList = this.$store.state.commonObj.districtList.find(item => item.value === districtnId)

        return districtList
    },
    getCityCorporationName (id = null) {
        id = this.profile.city_corporation_id
        const objectData = this.$store.state.commonObj.cityCorporationList.find(item => item.value === id)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return obj.text_bn
            } else {
                return obj.text_en
            }
        })
    },
    getDistributedQuantityRules (item) {
      let rules = 'numeric'
      if (item.distributed_quantity) {
        const allowableDistributedQuantity = parseInt(item.approved_quantity) - (item.previous_distributed_quantity)
        const maxValue = (item.stock_quantity < allowableDistributedQuantity) ? item.stock_quantity : allowableDistributedQuantity
        rules = 'required|numeric|max_value:' + maxValue
        // if (item.distributed_quantity > maxValue) {
        //   item.distributed_quantity = maxValue
        // }
      }
      return rules
    },
    isNumber: function (evt) {
        if (evt === 'undefined' || evt === null) {
            evt = window.event
        }
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault()
        } else {
            return true
        }
    },
    async register () {
       this.unitLoad = true
       const result = await RestApi.putData(awarenessEventServiceBaseUrl, distributionListDistribute + '/' + this.formData.id, this.formData)
      if (result.success) {
        if (result.notification && this.$store.state.emitNotification) {
          this.$socket.emit('send-notification', result.notification)
        }
        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.$t('globalTrans.save_msg')
        })
        this.unitLoad = false
        this.$router.push('distribution-receipt-list')
      } else {
        if (result.errors) {
          this.$refs.form.setErrors(result.errors)
        } else {
          this.$toast.error({
            title: this.$t('globalTrans.error'),
            message: result.message
          })
        }
        this.unitLoad = false
      }
    },
    getTotalInfo () {
      let totalNoOfQty = 0
      let totalStockQty = 0
      let totalApprovedQty = 0
      let totalPreviousDistributedQty = 0
      let totalDistributedQty = 0
      this.formData.details.forEach(item => {
        totalNoOfQty += parseInt(item.no_of_quantity)
        totalStockQty += parseInt(item.stock_quantity)
        totalApprovedQty += parseInt(item.approved_quantity)
        totalPreviousDistributedQty += parseInt(item.previous_distributed_quantity)
        totalDistributedQty += parseInt(item.distributed_quantity)
      })
      this.totalInfo = Object.assign({}, this.totalInfo, {
        stock_quantity: totalStockQty,
        no_of_quantity: totalNoOfQty,
        approved_quantity: totalApprovedQty,
        previous_distributed_quantity: totalPreviousDistributedQty,
        distributed_quantity: totalDistributedQty
      })
    }
 }
}
</script>
